import React, { useState } from 'react';
import { Bridge } from '@nackle/bridge';
import { AuthProvider } from './AuthProvider';
import { authSettings } from './authSettings';

export const BridgeAndProvider = ( { children } ) => {
    const [ authState, setAuthState ] = useState( {} );



    const handleAuthStateUpdate = async ( state ) => {
        setAuthState( {
            auth: state,
            loaded: true
        } );
    };
    return (
        <Bridge
            auth={ authSettings }
            onSignIn={ handleAuthStateUpdate }
            onSignOut={ handleAuthStateUpdate }
        >

            <AuthProvider value={ authState }>
                { children }
            </AuthProvider>
        </Bridge>
    );
};

export default BridgeAndProvider;
